// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-heading{color:#011638;margin-left:1rem;display:inline-block}", "",{"version":3,"sources":["webpack://./src/user/user.scss"],"names":[],"mappings":"AAEA,cACE,aAAA,CACA,gBAAA,CACA,oBAAA","sourcesContent":["@import '../scss/colors';\n\n.user-heading {\n  color: $dark-blue;\n  margin-left: 1rem;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
